import React from 'react';
import { GridHeaderCheckboxCell } from "./GridHeaderCheckboxCell";
export function gridHeaderCheckboxCell(config) {
    return function headerCellRenderer(_a) {
        var column = _a.column, cellIndex = _a.cellIndex;
        return (React.createElement(GridHeaderCheckboxCell, { key: "header-cell-" + cellIndex + "-" + column.id, onClick: config.onClick, checked: config.isChecked() }));
    };
}
//# sourceMappingURL=cell.js.map